import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';

const toast = useToast();
const useAboutUsStore = defineStore({
    id: 'aboutus',
    state: () => ({
        eggDescList: [
            {
                eggBackgroundObj: { componentName: 'aboutus', imgName: 'ethics', imgFormat: 'png' },
                label: 'aboutus.ethics'
            },
            {
                eggBackgroundObj: { componentName: 'aboutus', imgName: 'synergy', imgFormat: 'png' },
                label: 'aboutus.synergy'
            },
            {
                eggBackgroundObj: { componentName: 'aboutus', imgName: 'teamwork', imgFormat: 'png' },
                label: 'aboutus.teamwork'
            }
        ],
        photoDescList: [
            {
                id: 'wellInit',
                label: 'aboutus.wellInitTitle',
                description: 'aboutus.wellInitDesc',
                image: { componentName: 'aboutus', imgName: 'wellInit', imgFormat: 'svg' },
            },
            {
                id: 'healthAnalytics',
                label: 'aboutus.healthAnalyticsTitle',
                description: 'aboutus.healthAnalyticsDesc',
                image: { componentName: 'aboutus', imgName: 'healthAnalytics', imgFormat: 'svg' },

            },
            {
                id: 'employHealhMan',
                label: 'aboutus.employHealhManTitle',
                description: 'aboutus.employHealhManDesc',
                image: { componentName: 'aboutus', imgName: 'employHealhMan', imgFormat: 'svg' },

            },
            {
                id: 'medicalAdvisory',
                label: 'aboutus.medicalAdvisoryTitle',
                description: 'aboutus.medicalAdvisoryDesc',
                image: { componentName: 'aboutus', imgName: 'medicalAdvisory', imgFormat: 'svg' },

            }
        ]

    }),
    getters: {},
    actions: {
    },

});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAboutUsStore, import.meta.hot));
}

export { useAboutUsStore };
